const isMediaStreamTrack = source => (source &&
  typeof source === 'object' &&
  typeof source.kind === 'string' &&
  typeof source.stop === 'function' &&
  typeof source.enabled === 'boolean');
exports.isMediaStreamTrack = isMediaStreamTrack;
